import AccountingLockTypeApi from "../../../api/masterData/accountingLockTypeApi";

export default {
  namespaced: true,
  actions: {
    async fetch({dispatch}) {
      try {
        const response = await AccountingLockTypeApi.fetch();
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    }
  }
}
